namespace RioERP.Reports {
    export interface B2CGstReportSummaryForm {
        OrderMonth: Serenity.EnumEditor;
        OrderYear: Serenity.EnumEditor;
        TaxCategoryId: Serenity.LookupEditor;
        Taxcategory: Serenity.StringEditor;
        TotalTaxableAmount: Serenity.DecimalEditor;
        TotalTaxAmount: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
    }

    export class B2CGstReportSummaryForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.B2CGstReportSummary';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!B2CGstReportSummaryForm.init)  {
                B2CGstReportSummaryForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(B2CGstReportSummaryForm, [
                    'OrderMonth', w0,
                    'OrderYear', w0,
                    'TaxCategoryId', w1,
                    'Taxcategory', w2,
                    'TotalTaxableAmount', w3,
                    'TotalTaxAmount', w3,
                    'CgstAmount', w3,
                    'SgstAmount', w3,
                    'IgstAmount', w3,
                    'TotalTax', w3
                ]);
            }
        }
    }
}
